import React from "react";
import { Link } from "react-router-dom";
import "./LoungePass.css";

export default function LoungePass() {
  return (
    <div className="pass-page">
      <Link to="/lounges" className="back-link">← Lounges</Link>

      <section className="pass-hero">
        <h1 className="pass-title">Lounge Pass</h1>
        <p className="pass-status">Active</p>
      </section>

      <section className="pass-card">
        <div className="pass-card-top">
          <span className="pass-card-label">You're All Set</span>
          <span className="pass-card-check">✓</span>
        </div>

        <h2 className="pass-card-lounge">Dan Lounge</h2>
        <p className="pass-card-terminal">Terminal 3 · Ben Gurion</p>

        <div className="pass-card-details">
          <div className="pass-detail">
            <span className="pass-detail-label">Valid</span>
            <span className="pass-detail-value">Mar 15, 2026</span>
          </div>
          <div className="pass-detail">
            <span className="pass-detail-label">Guests</span>
            <span className="pass-detail-value">1 additional</span>
          </div>
          <div className="pass-detail">
            <span className="pass-detail-label">Card</span>
            <span className="pass-detail-value">•••• 4521</span>
          </div>
        </div>

        <div className="pass-qr">
          <div className="pass-qr-grid">
            {Array.from({ length: 49 }).map((_, i) => (
              <div
                key={i}
                className={`qr-cell ${i % 3 === 0 || i % 5 === 0 || i % 7 === 0 ? "dark" : ""}`}
              />
            ))}
          </div>
        </div>

        <p className="pass-qr-hint">Show QR + boarding pass at entrance</p>
      </section>

      <div className="pass-actions">
        <button type="button" className="pass-btn primary">Add to Wallet</button>
        <button type="button" className="pass-btn outline">Download PDF</button>
      </div>

      <p className="pass-tip">
        Works offline — download for access without WiFi
      </p>

      <section className="pass-perks">
        <span className="pass-perks-title">Included</span>
        <div className="pass-perks-list">
          <span className="pass-perk">Complimentary food</span>
          <span className="pass-perk">Premium drinks</span>
          <span className="pass-perk">Fast WiFi</span>
          <span className="pass-perk">Quiet workspace</span>
        </div>
      </section>

      <footer className="powered-by">Powered by Visa</footer>
    </div>
  );
}
